<template>
    <div class="rv-category mt-4 position-relative" v-click-outside="outSide">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="category.name != '' ? 'border-primary' : ''" type="text" id="inputCategory category-pro"
                v-model="category.name" @focus="focusInput"  :disabled="!check"
                @input="search()"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': category.name != ''
                }">Danh mục</label>
        </div>
        <div class="position-absolute w-100 pt-1 z-index-list" v-show="showDropdown">
            <div class="list">
                <div class="search-category">
                    <div class="line-loading" v-if="vloading"></div>
                    <div class="btn-search-category pl-10px text-primary fs-14px pt-2"
                        role="button" v-show="status_category == 2 && vloading == false" @click="status_category = 1">
                        Danh sách danh mục
                    </div>
                    <div class="back-category pl-10px text-danger pt-2" role="button"
                        v-show="id_cat.length > 0 && status_category == 1" @click="goBack()">
                        <i class="icon ion-md-arrow-back mr-2 fs-18px"></i>Quay lại
                    </div>
                </div>
                <div class="list-category vg-scrollbar" v-show="status_category == 1">
                    <div class="list-item p-10px"
                        role="button"
                        v-for="(category, index) in categories" :key="index"
                        @click="category.has_child ? getChild(category) : closeCategory(category)">
                        <span class="name fs-14px">{{ category.name }}</span>
                        <span class="icon float-right" v-if="category.has_child == true">
                            <i class="icon ion-ios-arrow-forward fs-16px"></i>
                        </span>
                    </div>
                </div>
                <div :class="{
                            'list-category vg-scrollbar': true,
                            'unset-height': categories_search.length == 0,
                        }" v-if="status_category == 2 && vloading == false">
                    <div class="list-item p-10px"
                        role="button"
                        v-for="(category, index) in categories_search" :key="index"
                        @click="closeCategory(category)">
                        <span class="name fs-14px">{{ category.name }}</span>
                    </div>
                    <div class="text-center my-4" v-show="categories_search.length == 0">
                        Không có kết quả tìm kiếm
                    </div>
                </div>
                <div class="searching my-4 text-center" v-if="vloading && status_category == 2">
                    Đang tìm kiếm...
                </div>
            </div>
        </div>
        <div class="category-suggest mt-1" >
            <p class="mb-0 fs-14px ml-2" v-if="suggest && suggest.length > 0">Gợi ý danh mục:</p>
            <div class="d-flex flex-wrap">
                <div :class="{
                        'fs-14px text-success px-1': true,
                        'mt-2': $detect == 'web',
                        'mt-3': $detect == 'mobile'
                    }" role="button" v-for="(item, index) in suggest" :key="index">
                    <span class="mb-0 text-category-suggest border border-success"
                        @click="closeCategory(item)">{{item.name}}</span>
                </div>
            </div>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error', 'suggest', 'title','namecat','check'],
    data() {
        return {
            category: {
                id: '',
                name: '',
            },
            status_category: 1,
            categories : [],
            id_cat: [],
            categories_search : [],
            vloading: false,
            showDropdown: false,
            timeOutStatus: null,
            searchByTitle: false,
        }
    },
    created() {
        // this.category.name = this.namecat;
        this.getCategory();
    },
    watch :{
        namecat(val){
            this.category.name = val;
        },
        data(val){
            this.category.id = val;
        },
    },
    methods: {
        emitData(){
            this.$emit('update:data', this.category.id)
        },
        async focusInput(e) {
            this.showDropdown = true;
            if(this.title && this.title.length >= 3 && !this.searchByTitle){
                this.status_category = 2;
                await this.getCategorySearch(this.title);
                this.searchByTitle = true;
            }
            if(this.category.id !== ''){
                e.target.select();
            }
            this.$emit('update:error', '');
        },
        search(){
            this.category.id = '';
            this.emitData();
            if(this.category.name.length >= 3){
                this.status_category = 2;
                this.vloading = true;
                if(this.timeOutStatus) clearTimeout(this.timeOutStatus);
                this.timeOutStatus = setTimeout(() => {
                    this.getCategorySearch();
                }, 300);
            }else if(this.category.name == 0){
                this.status_category = 1;
            }
        },
        async getCategory(parent_id = 0){
            await apiGet('/v1/categories', {
                module: 'product',
                parent_id: parent_id,
            }).then(res => {
                this.categories = res.data;
            });
        },
        async goBack() {
            this.vloading = true;
            let parent_id = 0;
            if(this.id_cat.length > 1) {
                parent_id = this.id_cat[this.id_cat.length -2];
            }
            await this.getCategory(parent_id);
            this.id_cat.splice(this.id_cat.length - 1, 1);
            this.vloading = false;
        },
        async getChild(category) {
            if(this.vloading) return;
            this.vloading = true;
            await this.getCategory(category.id);
            this.id_cat.push(category.id);
            this.vloading = false;
        },
        closeCategory(category) {
            this.category = {
                id: category.id,
                name: category.name
            };
            this.$emit('update:error', '');
            this.emitData();
            this.showDropdown = false;
        },
        async getCategorySearch(keyword = null) {
            if(this.category.name.length >= 3 || (keyword && keyword.length > 3)){
                this.vloading = true;
                await apiGet('/v2/products/suggest/suggest_category', {
                    keyword: keyword ? keyword : this.category.name
                }).then(res => {
                    this.categories_search = res.data.category;
                });
                this.vloading = false;
            }
        },
        outSide() {
            this.showDropdown = false;
        },
    }
}
</script>

<style lang="scss">
    .rv-create {
        .body { 
            .rv-category {
                input[type=text]:disabled {
                    background: rgba(0,0,0,.1);
                }
                .list {
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                    box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                    background: #fff;
                }
                .dropdown-category {
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #007bff;
                }
                .list-category {
                    height: 350px;
                    overflow-y: auto;
                }
                .unset-height {
                    height: unset !important;
                }
                .text-placeholder-category {
                    color: #999;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                }
                .text-name-category {
                    top: -13px;
                    padding: 0 10px;
                    background: #fff;
                    margin-left: 10px;
                }
                .z-index-list {
                    z-index: 2000;
                }
                .text-category-suggest {
                    border-radius: 40px;
                    padding: 3px 10px 5px;
                }
                .line-loading {
                    width: 100%;
                    height: 3px;
                    position: relative;
                    &:before {
                        content: "";
                        position: absolute;
                        right: auto;
                        left: 0;
                        height: 100%;
                        background-color: #0c81f6;
                        animation: lineLoading 1s forwards infinite linear;
                    }
                }
                @keyframes lineLoading {
                    0% {
                        right: 100%;
                    }

                    50% {
                        right: 0;
                        left: 0;
                    }

                    100% {
                        right: 0;
                        left: 100%;
                    }
                }
            }
        }
    }
</style>
